export const LOCAL_STORAGE_KEYS = {
  COPILOT_CHAT_DATA: 'copilotChatData',
  COUNTRY_BBOX: 'countryBbox'
};

export const SESSION_STORAGE_KEYS = {
  PRE_LOGIN_ROUTE: 'pre_login_route'
};

export function storeToLocalStorage(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function getFromLocalStorage(key: string) {
  return localStorage.getItem(key);
}

export function removeFromLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export function saveCurrentRouteForLogin(currentRoute?: string) {
  try {
    const route = currentRoute || '';
    sessionStorage.setItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE, route);
  } catch (error) {
    console.error('Failed to save route to session storage:', error);
  }
}

export function clearPreLoginRoute() {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE);
  } catch (error) {
    console.error('Failed to clear route from session storage:', error);
  }
}

export function getPreLoginRoute(): string | null {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEYS.PRE_LOGIN_ROUTE);
  } catch (error) {
    console.error('Failed to retrieve preserved route:', error);
    return null;
  }
}

export interface CachedBboxData {
  bbox: [number, number, number, number];
  country: string;
  expiresAt: number;
}

export function getCachedBbox(): {
  data: CachedBboxData | null;
  isExpired: boolean;
} {
  try {
    const cached = getFromLocalStorage(LOCAL_STORAGE_KEYS.COUNTRY_BBOX);
    if (!cached) return { data: null, isExpired: false };

    const data = JSON.parse(cached) as CachedBboxData;

    if (data.bbox && data.bbox.length === 4) {
      return { data, isExpired: Date.now() > data.expiresAt };
    }

    return { data: null, isExpired: false };
  } catch {
    return { data: null, isExpired: false };
  }
}

export function setCachedBbox(
  bbox: CachedBboxData['bbox'],
  country: CachedBboxData['country']
): void {
  try {
    const CACHE_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

    const data: CachedBboxData = {
      bbox,
      country,
      expiresAt: Date.now() + CACHE_EXPIRY_MS
    };

    storeToLocalStorage(LOCAL_STORAGE_KEYS.COUNTRY_BBOX, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to cache bbox:', error);
  }
}
